// Generated by LiveScript 1.6.0
var ref$, id, log, filter, pub, urlToParts, partsToUrl, originalTitle, pushState, replaceState, out$ = typeof exports != 'undefined' && exports || this;
ref$ = require('utils'), id = ref$.id, log = ref$.log, filter = ref$.filter;
pub = require('./pubsub').pub;
out$.urlToParts = urlToParts = function(it){
  return filter(id, it.split('/'));
};
out$.partsToUrl = partsToUrl = function(it){
  return '/' + it.join('/');
};
originalTitle = document.title;
out$.pushState = pushState = function(urlParts, title){
  if (Modernizr.history) {
    history.pushState(null, originalTitle, partsToUrl(urlParts));
  }
  return pub('history-push', urlParts);
};
out$.replaceState = replaceState = function(urlParts, title){
  if (Modernizr.history) {
    history.replaceState(null, originalTitle, partsToUrl(urlParts));
  }
  return pub('history-push', urlParts);
};
window.onpopstate = function(event){
  var url;
  url = urlToParts(window.location.pathname);
  return pub('history-pop', url);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhpc3RvcnkubHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSxJQUFBLEdBQXNCLE9BQXRCLENBQThCLE9BQUEsQ0FBOUIsRUFBRSxFQUFrQixDQUFBLENBQUEsQ0FBcEIsSUFBQSxDQUFBLEVBQUEsRUFBTSxHQUFjLENBQUEsQ0FBQSxDQUFwQixJQUFBLENBQUEsR0FBQSxFQUFXLE1BQVMsQ0FBQSxDQUFBLENBQXBCLElBQUEsQ0FBQTtBQUNFLEdBQU0sQ0FBQSxDQUFBLENBQUUsT0FBVixDQUFrQixVQUFBLENBQWxCLENBQUE7a0JBS08sVUFBYSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsRUFBQTtTQUFHLE9BQU8sSUFBSSxFQUFFLENBQUMsTUFBTSxHQUFBLENBQWI7O2tCQUN6QixVQUFhLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxFQUFBO1NBQUcsR0FBSSxDQUFBLENBQUEsQ0FBRSxFQUFFLENBQUMsSUFBTCxDQUFVLEdBQUE7O0FBS3ZDLGFBQWUsQ0FBQSxDQUFBLENBQUUsUUFBUSxDQUFDO2lCQUtuQixTQUFXLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxRQUFBLEVBQUEsS0FBQTtFQUNsQixJQUFHLFNBQVMsQ0FBQyxPQUFiO0lBQ0UsT0FBTyxDQUFDLFVBQVcsTUFBTSxlQUFnQixXQUFhLFFBQUEsQ0FBbkM7O1NBQ3JCLElBQUksZ0JBQWdCLFFBQWhCOztvQkFFQyxZQUFjLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxRQUFBLEVBQUEsS0FBQTtFQUNyQixJQUFHLFNBQVMsQ0FBQyxPQUFiO0lBQ0UsT0FBTyxDQUFDLGFBQWMsTUFBTSxlQUFnQixXQUFhLFFBQUEsQ0FBbkM7O1NBQ3hCLElBQUksZ0JBQWdCLFFBQWhCOztBQUtOLE1BQU0sQ0FBQyxVQUFXLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxLQUFBOztFQUNsQixHQUFJLENBQUEsQ0FBQSxDQUFFLFdBQWEsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFoQjtTQUNuQixJQUFJLGVBQWUsR0FBZiIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19

